<template>
  <div>
    <Title :pages="[{ icon: 'book', page: page_title.toUpperCase() }]"></Title>

    <v-container fluid>
      <ModalAsiento
        formBtn=""
        modal_title="Asiento"
        :dialog="dialog"
        :service="service"
        :emitters="emitters"
        :item="mainItem"
        @updateDialog="updateDialog"
        @updateItem="
          (newItem) => {
            mainItem = newItem;
          }
        "
      />

      <!-- Filtros -->
      <v-card>
        <div class="row mb-2 mt-0">
          <div class="col-md-12" v-if="list_access">
            <div class="col-md-12 elevation-0" style="background: white">
              <div class="row pt-5">
                <div class="col-md-3 pt-0">
                  <v-combobox v-model="emitter_selected" autocomplete="off" item-text="name" item-value="id" :items="emitters" label="Emisor" class="pt-0 mt-0" return-object @change="onEmitterChange"></v-combobox>
                </div>

                <div class="col-md-3 pt-0">
                  <v-autocomplete v-model="account_selected" autocomplete="off" item-text="label" item-value="id" :items="accounts" label="Cuenta" class="pt-0 mt-0" return-object :no-data-text="emitter_selected ? 'Sin cuentas' : 'Seleccioná un emisor'"></v-autocomplete>
                </div>

                <div class="col-md-2 pt-0">
                  <v-menu
                    ref="desde_menu"
                    v-model="desde_menu"
                    :close-on-content-click="false"
                    :return-value.sync="desde_selected"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="desde_selected" label="Desde" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" class="pt-0 mt-0"></v-text-field>
                    </template>
                    <v-date-picker v-model="desde_selected" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="desde_menu = false">Cancelar</v-btn>
                      <v-btn text color="primary" @click="$refs.desde_menu.save(desde_selected)">OK</v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>

                <div class="col-md-2 pt-0">
                  <v-menu
                    ref="hasta_menu"
                    v-model="hasta_menu"
                    :close-on-content-click="false"
                    :return-value.sync="hasta_selected"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="hasta_selected" label="Hasta" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" class="pt-0 mt-0"></v-text-field>
                    </template>
                    <v-date-picker v-model="hasta_selected" no-title scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="hasta_menu = false">Cancelar</v-btn>
                      <v-btn text color="primary" @click="$refs.hasta_menu.save(hasta_selected)">OK</v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>

                <div class="col-md-2 pt-0">
                  <v-combobox v-model="cost_center_selected" autocomplete="off" item-text="name" item-value="id" :items="cost_centers" label="Centro de Costo" class="pt-0 mt-0" clearable></v-combobox>
                </div>

                <div class="col pt-0" style="display: flex; justify-content: end">
                  <v-btn color="info" :disabled="!emitter_selected || !account_selected" @click="filter">Buscar</v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-card>

      <!-- Mayor -->
      <v-card>
        <v-card-title>
          <span class="text-uppercase">{{ page_title }}</span>
          <span v-if="data" class="ml-3 grey--text">{{ data.account.label }}</span>
          <v-spacer></v-spacer>
          <v-btn color="blue-grey" small dark :loading="dialog_export" :disabled="loading || !data" @click="exportFile"> Exportar <font-awesome-icon class="ml-2" icon="download" /></v-btn>
        </v-card-title>

        <v-progress-linear v-if="loading" indeterminate color="info"></v-progress-linear>

        <div class="pa-2" style="overflow-x: auto">
          <div v-if="loading" class="pa-6 text-center grey--text">Cargando...</div>

          <v-simple-table v-else-if="data" dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Fecha</th>
                  <th class="text-left">Asiento</th>
                  <th class="text-left">Descripción</th>
                  <th class="text-left">Detalle</th>
                  <th class="text-left">Centro de Costo</th>
                  <th class="text-left">Concepto</th>
                  <th class="text-right">Debe</th>
                  <th class="text-right">Haber</th>
                  <th class="text-right">Saldo</th>
                </tr>
              </thead>
              <tbody>
                <tr class="grey lighten-3">
                  <td colspan="4" class="font-weight-bold">Saldo inicial al {{ desde_selected }}</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td class="text-right font-weight-bold">{{ formatUtils.formatPrice(data.saldo_inicial) }}</td>
                </tr>

                <tr v-for="(mov, i) in data.movimientos" :key="'mov-' + i">
                  <td>{{ mov.date_esp }}</td>
                  <td>
                    <a class="blue--text text-decoration-none" @click="viewAsiento(mov.asiento_id)">{{ mov.number ? mov.number : "#" + mov.asiento_id }}</a>
                  </td>
                  <td>{{ mov.asiento_description }}</td>
                  <td>{{ mov.description }}</td>
                  <td>{{ mov.cost_center ? mov.cost_center.name : "" }}</td>
                  <td>{{ mov.concepto ? mov.concepto.name : "" }}</td>
                  <td class="text-right">{{ formatUtils.formatPrice(mov.debe) }}</td>
                  <td class="text-right">{{ formatUtils.formatPrice(mov.haber) }}</td>
                  <td class="text-right">{{ formatUtils.formatPrice(mov.saldo) }}</td>
                </tr>

                <tr v-if="data.movimientos.length === 0">
                  <td colspan="9" class="text-center grey--text py-4">La cuenta no tuvo movimientos en el período.</td>
                </tr>

                <tr class="blue lighten-5">
                  <td colspan="6" class="font-weight-bold">Totales del período</td>
                  <td class="text-right font-weight-bold">{{ formatUtils.formatPrice(data.totales.debe) }}</td>
                  <td class="text-right font-weight-bold">{{ formatUtils.formatPrice(data.totales.haber) }}</td>
                  <td class="text-right font-weight-bold">{{ formatUtils.formatPrice(data.totales.saldo_final) }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>

          <div v-else class="pa-6 text-center grey--text">Elegí emisor, cuenta y período, y presioná Buscar.</div>
        </div>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import Constant from "@/constants/sections";
import { generalService } from "@/libs/ws/generalService";
import { emmiterService } from "@/libs/ws/emmiterService";
import { formatUtils } from "@/libs/utils/formatUtils";

import GenericMixin from "@/mixins/GenericMixin.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import ExportMixin from "@/mixins/ExportMixin.vue";
import Title from "@/components/Title.vue";
import ModalAsiento from "../Asientos/Modal.vue";

export default {
  components: { Title, ModalAsiento },
  mixins: [GenericMixin, RolMixin, ExportMixin],
  data() {
    return {
      page_title: "Libro Mayor",
      service: generalService,
      mainItem: { id: "", date: "", description: "", emitter: null, lineas: [] },
      defaultItem: { id: "", date: "", description: "", emitter: null, lineas: [] },
      formatUtils: formatUtils,
      data: null,
      desde_menu: false,
      hasta_menu: false,
      desde_selected: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().slice(0, 10),
      hasta_selected: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).toISOString().slice(0, 10),
      emitters: [],
      emitter_selected: null,
      accounts: [],
      account_selected: null,
      cost_centers: [],
      cost_center_selected: null,
    };
  },
  mounted() {
    this.loadCombos();
  },
  methods: {
    loadCombos() {
      emmiterService.filter({ enabled: true }).then((response) => {
        this.emitters = response.result || [];
        if (this.emitters.length > 0) {
          this.emitter_selected = this.emitters[0];
          this.loadAccounts();
        }
      });
      generalService.filter({}, Constant.SECTION_COSTS_CENTERS).then((response) => {
        this.cost_centers = response.result;
      });
    },
    onEmitterChange() {
      // El plan de cuentas es por emisor: la cuenta elegida deja de ser válida.
      this.account_selected = null;
      this.data = null;
      this.loadAccounts();
    },
    loadAccounts() {
      if (this.emitter_selected == null) {
        this.accounts = [];
        return;
      }
      generalService.filter({ emitter: this.emitter_selected.id, imputable: true }, Constant.SECTION_ACCOUNTS).then((response) => {
        this.accounts = response.result || [];
      });
    },
    getFilterParams() {
      return {
        emitter: this.emitter_selected != null ? this.emitter_selected.id : null,
        account: this.account_selected != null ? this.account_selected.id : null,
        from: this.desde_selected,
        to: this.hasta_selected,
        cost_center: this.cost_center_selected != null ? this.cost_center_selected.id : null,
      };
    },
    filter() {
      if (this.emitter_selected == null || this.account_selected == null) return;
      this.loading = true;
      generalService
        .query(this.getFilterParams(), Constant.SECTION_REPORT_MAYOR)
        .then((response) => {
          if (!response.status) {
            this.$toast.error(response.msg, "Error");
            return;
          }
          this.data = response.result;
        })
        .catch((e) => console.log(e))
        .finally(() => (this.loading = false));
    },
    viewAsiento(asiento_id) {
      generalService.filter({ id: asiento_id, emitter: this.emitter_selected.id }, Constant.SECTION_ASIENTOS).then((response) => {
        if (!response.status || !response.result || response.result.length === 0) {
          this.$toast.error(response.msg || "No se encontró el asiento", "Error");
          return;
        }
        this.mainItem = response.result[0];
        this.dialog = true;
      });
    },
    exportFile() {
      const param = this.getFilterParams();
      param.export = true;
      this.exportExcel(Constant.SECTION_REPORT_MAYOR, param, "Libro-Mayor.xlsx");
    },
  },
};
</script>
